// BCM-898 · PA7 — Pre-shipment documents not received (slide 22). [Shekar]
// Status 39 (Specs Approved), rendered only when the "Pre-shipment documents not
// received" requirement is PRESENT (that presence IS the PF!=5 test — handled by
// the resolver). Informational only. Identical construction to PA1 with the
// category switched.
import React from "react";
import DocumentsPendingCard from "../components/common/DocumentsPendingCard";
import { DOC_CATEGORY } from "../utils/constants";

const PA7PreShipmentDocuments = ({ row, viewOnly }) => (
  <DocumentsPendingCard
    row={row}
    category={DOC_CATEGORY.PRE_SHIPMENT}
    title="Pre-Shipment documents are not yet received"
    successTitle="All pre-shipment documents have been received"
    subText="The batch will not move ahead unless the pending documents listed below are received."
    viewOnly={viewOnly}
  />
);

export default PA7PreShipmentDocuments;
